import { render, staticRenderFns } from "./Fx.vue?vue&type=template&id=74d2c912&scoped=true&"
import script from "./Fx.vue?vue&type=script&lang=js&"
export * from "./Fx.vue?vue&type=script&lang=js&"
import style0 from "./Fx.vue?vue&type=style&index=0&id=74d2c912&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d2c912",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VSelect,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d2c912')) {
      api.createRecord('74d2c912', component.options)
    } else {
      api.reload('74d2c912', component.options)
    }
    module.hot.accept("./Fx.vue?vue&type=template&id=74d2c912&scoped=true&", function () {
      api.rerender('74d2c912', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Calculator/Fx.vue"
export default component.exports